<template>
    <div class="height-100-p">
        <!--v-loading="daysOfServiceManagement.loadingSearch"-->
        <el-table
        :data="chargeCode.list"
        v-loading="chargeCode.loadingSearch"
        id="daysOfServiceManagement-data-list"
        ref="dayOfServiceManagementTable"
        size="mini"
        tooltip-effect="dark"
        class="dark-blue-table"
        :empty-text="$t('common.notAbleToFindRecords')"
        @sort-change="handleSortChange"
        stripe
    >
        <el-table-column prop="name" :label="$t('tariff.chargeCodes.management.name')" :min-width="7"
                       align="center" sortable="custom">
                      <template slot-scope="scope">
                        <el-tooltip class="item"
                          effect="dark"
                          :enterable="false"
                          :content="scope.row.name"
                          placement="top-start">
                            <span>{{ scope.row.name }}</span>
                        </el-tooltip>
                      </template>
                      </el-table-column>

        <el-table-column prop="code" :label="$t('tariff.chargeCodes.management.code')" :min-width="7"
                       align="center" sortable="custom"></el-table-column>

        <el-table-column prop="chargeType" :label="$t('tariff.chargeCodes.management.type')" :min-width="7"
                       align="center" sortable="custom">
                      <template v-slot="scope">
                        <span>
                          {{ getChargeCodeType(scope.row.chargeType)}}
                        </span>
                      </template>
                      </el-table-column>

        <el-table-column prop="revenueCharge" :label="$t('tariff.chargeCodes.management.revenueCharge')" :min-width="7"
                       align="center" sortable="custom">
                      <template v-slot="scope">
                        <span v-if="scope.row.revenueCharge">
                          <i class="el-icon-check" size="mini"></i>
                        </span>

                      </template>

                      </el-table-column>

        <el-table-column prop="priority" :label="$t('tariff.chargeCodes.management.priority')" :min-width="7"
                       align="center" sortable="custom"></el-table-column>

        <el-table-column prop="active" :label="$t('tariff.chargeCodes.management.status')" :min-width="7"
                       align="center" sortable="custom">
                      <template v-slot="scope">
                        <span>
                          {{ getChargeCodeStatus(scope.row.status)}}
                        </span>
                      </template>
                      </el-table-column>

        <el-table-column prop="department" :label="$t('tariff.chargeCodes.management.department')" :min-width="7"
                       align="center" sortable="custom"></el-table-column>

        <el-table-column prop="location" :label="$t('tariff.chargeCodes.management.location')" :min-width="7"
                       align="center" sortable="custom"></el-table-column>

        <el-table-column prop="sageAccount" :label="$t('tariff.chargeCodes.management.sageAccount')" :min-width="7"
                       align="center" sortable="custom"></el-table-column>

        <el-table-column prop="action" :label="$t('tariff.chargeCodes.management.options')" :min-width="7"
                       align="center">
                      <template slot-scope="scope">
                        <span id = "charge-code-lst-actions">
                          <detail-charge-code :chargeCode="scope.row"/>
                          <add-charge-code :chargeCode="scope.row"/>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :enterable="false"
                            :content="$t('common.delete')"
                            placement="top-start">
                            <i class="el-icon-delete icon-action" @click="handleDelete(scope.row)"></i>
                          </el-tooltip>
                        </span>
                      </template>

        </el-table-column>
    </el-table>

    <div class="pagination-footer" v-show="chargeCode.total  > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('tariff.chargeCodes.totalChargeCodes') }}</span>
           {{ chargeCode.total }}
      </span>
      <el-pagination
          @size-change="handleSearchChangeLimit"
          :page-sizes="sizes"

          @current-change="handleSearchChangePage"
          :total="chargeCode.total"
          layout="sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import { CHARGE_CODE_DELETE, CHARGE_CODE_LIST_SEARCH } from '@/store/actions';
import DetailChargeCode from './components/detailChargeCode/detailChargeCode';
import AddChargeCode from './components/addChargeCode/addChargeCode';


export default {
  name: 'SearchSummaryList',
  computed: {
    ...mapGetters(['chargeCode'])
  },
  components: {
    DetailChargeCode,
    AddChargeCode,
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,


    };
  },
  methods: {
    getChargeCodeType(recrdType) {
      // eslint-disable-next-line eqeqeq
      return recrdType;
      // return constants.CHARGE_CODE.CHARGE_CODE_TYPES.find(ct => ct.value == recrdType).label;
    },

    async handleDelete(row) {
      Message.close();

      const confirm = await this.$confirm(
        this.$t('tariff.chargeCodes.deleteChargeCodeMessage'),
        { confirmText: this.$t('common.delete'), dangerouslyUseHTMLString: true }
      ).catch(() => {});

      if (confirm) {
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        try {
          const response = await this.$store.dispatch(CHARGE_CODE_DELETE, row.id);
          this.$message.success(response.message);
        } finally {
          loading.close();
          await this.$store.dispatch(CHARGE_CODE_LIST_SEARCH, {});
        }
      }
    },

    handleSearchChangePage(val) {
      this.$store.dispatch(CHARGE_CODE_LIST_SEARCH, { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch(CHARGE_CODE_LIST_SEARCH, { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    getChargeCodeStatus(status) {
      return status ? this.$t('tariff.chargeCodes.active') : this.$t('tariff.chargeCodes.inactive');
    },
    handleSortChange({ prop, order }) {
      this.$store.dispatch(CHARGE_CODE_LIST_SEARCH, {
        orderField: prop,
        orderDirection: constants.TABLES.ORDER_DIRECTION[order]
      });
    },
  },
};
</script>
